import { render } from "./PetikomEnterprise.vue?vue&type=template&id=46dc377a&scoped=true"
import script from "./PetikomEnterprise.vue?vue&type=script&lang=js"
export * from "./PetikomEnterprise.vue?vue&type=script&lang=js"

import "./PetikomEnterprise.vue?vue&type=style&index=0&id=46dc377a&lang=scss&scoped=true"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dc377a"]])

export default __exports__